import { __assign, __decorate, __extends } from "tslib";
import * as React from 'react';
import { withMarketplaceStore, } from '../../component-decorators/with-marketplace-store';
import { UpgradeSiteModal } from './upgarde-site-modal';
import { ConnectDomainModal } from './connect-domain-modal';
import { ReviewAppModal } from '@wix/app-market-collection-widget/';
import { config } from '../../config';
import { AdiEditorModal } from './adi-editor-modal';
import { SwitchToEditorModal } from './switch-to-editor-modal';
import { NotSupportedInEditorXModal } from './not-supported-in-editor-x-modal';
import { useConfigContext } from '../../config-context';
import { SupportModal, Origin } from '@wix/manage-installed-apps';
import { InstallationNotSupportedMobile } from './installation-not-supported-mobile';
import { OtherCountriesModal } from "../solution-page/solution-page-views/solution-overview/other-countries/other-countries-modal";
export var ModalNames;
(function (ModalNames) {
    ModalNames["NONE"] = "none";
    ModalNames["UPGRADE_SITE"] = "upgradeSite";
    ModalNames["CONNECT_DOMAIN"] = "connectDomain";
    ModalNames["RATE_APP"] = "rateApp";
    ModalNames["EDIT_REVIEW"] = "editReview";
    ModalNames["ADI_EDITOR"] = "adiEditor";
    ModalNames["SWITCH_TO_EDITOR"] = "switchToEditor";
    ModalNames["NOT_SUPPORTED_IN_EDITORX"] = "notSupportedInEditorX";
    ModalNames["SUPPORT_MODAL"] = "supportModal";
    ModalNames["INSTALLATION_NOT_SUPPORTED_MOBILE"] = "InstallationNotSupportedMobile";
    ModalNames["OTHER_COUNTRIES_MODAL"] = "OtherCountriesModal";
})(ModalNames || (ModalNames = {}));
export var Modals = function (props) {
    var configContext = useConfigContext();
    return React.createElement(ConnectedModals, __assign({}, props, { configContext: configContext }));
};
var ConnectedModals = /** @class */ (function (_super) {
    __extends(ConnectedModals, _super);
    function ConnectedModals() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConnectedModals.prototype.render = function () {
        var _a = this.props, marketplaceStore = _a.marketplaceStore, configContext = _a.configContext;
        var shouldOpenNewReviewModal = marketplaceStore.openedModalName === ModalNames.RATE_APP ||
            marketplaceStore.openedModalName === ModalNames.EDIT_REVIEW;
        var showSuccessToast = function (message) {
            if (configContext.showUserActionNotification) {
                configContext.showUserActionNotification({
                    message: message,
                    biName: 'review-app',
                    type: 'SUCCESS',
                });
            }
        };
        // @ts-ignore
        // @ts-ignore
        return (React.createElement(React.Fragment, null,
            marketplaceStore.openedModalName === ModalNames.UPGRADE_SITE && (React.createElement(UpgradeSiteModal, __assign({}, marketplaceStore.openedModalProps))),
            marketplaceStore.openedModalName === ModalNames.CONNECT_DOMAIN && (React.createElement(ConnectDomainModal, __assign({}, marketplaceStore.openedModalProps))),
            shouldOpenNewReviewModal && (React.createElement(ReviewAppModal, { locale: configContext.locale, appDefId: marketplaceStore.openedModalProps.app.baseInfo.id, isOpen: true, closeFn: marketplaceStore.openedModalProps.closeModal, afterCloseFn: marketplaceStore.openedModalProps.optionCB, showSuccessToast: showSuccessToast, additionalBiData: {
                    msid: marketplaceStore.metaSiteId,
                    tagType: 'app_page',
                    platform: config.originForBI,
                } })),
            marketplaceStore.openedModalName === ModalNames.ADI_EDITOR && (React.createElement(AdiEditorModal, __assign({}, marketplaceStore.openedModalProps))),
            marketplaceStore.openedModalName === ModalNames.SWITCH_TO_EDITOR && (React.createElement(SwitchToEditorModal, __assign({}, marketplaceStore.openedModalProps))),
            marketplaceStore.openedModalName ===
                ModalNames.INSTALLATION_NOT_SUPPORTED_MOBILE && (React.createElement(InstallationNotSupportedMobile, __assign({}, marketplaceStore.openedModalProps))),
            marketplaceStore.openedModalName ===
                ModalNames.NOT_SUPPORTED_IN_EDITORX && (React.createElement(NotSupportedInEditorXModal, __assign({}, marketplaceStore.openedModalProps))),
            marketplaceStore.openedModalName ===
                ModalNames.OTHER_COUNTRIES_MODAL && (React.createElement(OtherCountriesModal, __assign({ subtitle: marketplaceStore.openedModalProps.subtitle, closeModal: marketplaceStore.openedModalProps.closeModal, countries: marketplaceStore.openedModalProps.countries, footerTwo: marketplaceStore.openedModalProps.footerTwo, onSupportClick: marketplaceStore.openedModalProps.onSupportClick }, marketplaceStore.openedModalProps))),
            marketplaceStore.openedModalName === ModalNames.SUPPORT_MODAL && (React.createElement(SupportModal, { locale: configContext.locale, baseUrl: config.baseApiUrl, closeModal: marketplaceStore.openedModalProps.closeModal, origin: config.origin === 'editor' ? Origin.EDITOR : Origin.BIZMGR, app: marketplaceStore.openedModalProps.app, msId: marketplaceStore.metaSiteId, authorizationHeader: configContext.getAppInstance &&
                    configContext.getAppInstance('22bef345-3c5b-4c18-b782-74d4085112ff'), 
                // authorizationHeader={'1234'}
                manageAppsStaticsUrl: config.manageAppsStaticsUrl, clickSource: marketplaceStore.openedModalProps.clickSource, pageName: marketplaceStore.openedModalProps.pageName, showUserActionNotification: configContext.showUserActionNotification }))));
    };
    ConnectedModals = __decorate([
        withMarketplaceStore
    ], ConnectedModals);
    return ConnectedModals;
}(React.Component));
export { ConnectedModals };
//# sourceMappingURL=modals.js.map